import { render, staticRenderFns } from "./welcome.vue?vue&type=template&id=79e8a00b&scoped=true"
import script from "./welcome.vue?vue&type=script&lang=js"
export * from "./welcome.vue?vue&type=script&lang=js"
import style0 from "./welcome.vue?vue&type=style&index=0&id=79e8a00b&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e8a00b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79e8a00b')) {
      api.createRecord('79e8a00b', component.options)
    } else {
      api.reload('79e8a00b', component.options)
    }
    module.hot.accept("./welcome.vue?vue&type=template&id=79e8a00b&scoped=true", function () {
      api.rerender('79e8a00b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/welcome/welcome.vue"
export default component.exports